<div class="second-part flex">
  <div class="title">目前支持同时观影的平台</div>
  <div class="subtitle">持续更新中…</div>
  <div class="imgs">
    <img
      *ngFor="let item of [1, 2, 3, 4, 5]"
      src="../../../assets/images/popcorn/seond-part-{{ item }}.webp"
      width="135"
      height="134"
      alt=""
    />
  </div>
</div>
<div class="third-part flex">
  <div class="title">为什么选择“爆米花”？</div>
  <div class="cards">
    <div class="item">
      <img
        src="../../../../assets/images/popcorn/third-icon-1.webp"
        alt=""
        [width]="126"
        [height]="108"
      />
      <div class="title">丰富资源</div>
      <div class="content">
        覆盖全球90%的影视资源<br />
        电影，电视剧，动漫<br />应有尽有
      </div>
    </div>
    <div class="item">
      <img
        src="../../../../assets/images/popcorn/third-icon-2.webp"
        alt=""
        [width]="126"
        [height]="108"
      />
      <div class="title">操作方便</div>
      <div class="content">
        无需登入<br />无需验证<br />不掉线不封号<br />一个号通用五个平台
      </div>
    </div>
    <div class="item">
      <img
        src="../../../../assets/images/popcorn/third-icon-3.webp"
        alt=""
        [width]="126"
        [height]="108"
      />
      <div class="title">价格低廉</div>
      <div class="content">
        破价至冰点<br />节省最少八成以上<br />没有预算压力<br />轻松拿下
      </div>
    </div>
    <div class="item">
      <img
        src="../../../../assets/images/popcorn/third-icon-4.webp"
        alt=""
        [width]="126"
        [height]="108"
      />
      <div class="title">专业团队</div>
      <div class="content">
        专业工程师团队<br />定期维护<br />专业客服团队<br />排忧解惑
      </div>
    </div>
  </div>
</div>
<div class="button">
  <button routerLink="/popcorn/after">使用教程</button>
</div>
